import React from 'react';

//components
import BasicButton from '../../../global/buttons/BasicButton';
import Icon from '../../../global/icons/Icon';

//interfaces
import { IRemoveConditionButton } from '../../interfaces/IConditionalLogicPanel';
import { IconLibrary } from '../../../../interfaces/icon/IconLibrary';


const RemoveConditionButton = (
    { 
        showButton,
        buttonLabel,
        onButtonClick
    }: IRemoveConditionButton) => {

    if (!showButton) {
        return <></>
    }
    return (
        <BasicButton 
            className='remove-condition-button'
            ariaLabel={buttonLabel ?? 'Remove Condition'} 
            content={<Icon iconName={IconLibrary.BIN} sizeInPx='12' color='var(--thriveGreyDark)'/> }
            onButtonClick={onButtonClick}
        />                
    );
};

export default RemoveConditionButton